//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0]],[[["numSymbols"],"GetSymbols",{R_:{symbols:""}},0,0],[["symbols"],"SetSymbols",{},1,0],[["numSymbols"],"GetSymbolsV2",{R_:{symbols:""}},0,0],[["symbols"],"SetSymbolsV2",{},1,0]],[]];
SPLM.Mechatronics.SymbolTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SymbolTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SymbolTableBuilder.Symbol = class{
    constructor(name,eIOType,eDataType,address,comment){
        this.name=name;this.eIOType=eIOType;this.eDataType=eDataType;this.address=address;this.comment=comment;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Address(){return this.address}
    set Address(val){this.address = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
};

SPLM.Mechatronics.SymbolTableBuilder.SymbolV2 = class{
    constructor(name,originalName,eIOType,eDataType,address,comment){
        this.name=name;this.originalName=originalName;this.eIOType=eIOType;this.eDataType=eDataType;this.address=address;this.comment=comment;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Originalname(){return this.originalName}
    set Originalname(val){this.originalName = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Address(){return this.address}
    set Address(val){this.address = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
};

SPLM.Mechatronics.SymbolTableBuilder.IOType = Object.freeze({
    "Input" : "Input", "Output" : "Output", "Inout" : "Inout"});

SPLM.Mechatronics.SymbolTableBuilder.DataType = Object.freeze({
    "Bool" : "Bool", "Int" : "Int", "Double" : "Double", "String" : "String"});

export default SPLM;